import { observer } from 'mobx-react';
import * as React from 'react';

import { i18next } from '../../../internationalization/i18next';
import { PageLayout } from '../../common/page-layout/page-layout';
import { Button } from '../../widgets/button/button';

export interface NotLoggedInScreenProps {
  logoUrl: string;
  onClickLogin(): Promise<void>;
}

/**
 * Screen show to users when they haven't logged in
 */
@observer
export class NotLoggedInScreen extends React.Component<NotLoggedInScreenProps> {
  /** Renders the page */
  render() {
    return (
      <PageLayout logoUrl={this.props.logoUrl}>
        <div>
          {i18next.t('not-logged-in.info', 'Click the button below to login to skillseeker')}
          <div>
            <div style={{ marginTop: '30px' }}></div>

            <Button variant="round" onClick={this.props.onClickLogin}>
              {i18next.t('not-logged-in.login', 'Login')}
            </Button>
          </div>
        </div>
      </PageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/screens/not-logged-in-screen/not-logged-in-screen.tsx